///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.new_consumer_vendor = abcsetup.dashboard.new_consumer_vendor || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.new_consumer_vendor = {
    init: function() {
        $('#add-alternate-user-btn').on('click', function (e) {
            abcsetup.blockUI(true);
            axios.get('/api/new_vendor/get_user_suppliers')
            .then(function(response) {
                var vendors = response.data;

                $('#vendorSelect').empty().append('<option value="">-- Select a Vendor --</option>');

                $.each(vendors, function(index, vendor) {
                    $('#vendorSelect').append(
                        $('<option>', {
                            value: vendor.id,
                            text: vendor.name
                        })
                    );
                });
                abcsetup.unblockUI();
                $('#newVendorAddAlternateUserModal').modal('show');
            })
            .catch(function(error) {
                console.error('Error fetching vendors:', error);
            });
        });
    },
}